export const ProcessType=[
    
    {
      processType:"Exact Match",
      matched:false,
      description:"The question was exactly matched with one of the trained questions "
    },
    {
        processType:"Intent Match",
        matched:false,
        description:"The intent of the question was matched with one of the trained questions with no modifications in SQL"
    },
    {
        processType:"Boundary Change",
        matched:false,
        description:"The intent of the question was matched with one of the trained questions with some modifications in SQL"
      },
    {
        processType:"Sql Generation",
        matched:false,
        description:"The question was not matched with any of the trained questions, a new SQL was generated."
      },
   
]